import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../custom.css';
import Logo from './images/logo1.png';
import Human from './images/human1.png';
import LanguageSelector from './language/LanguageSelector';
import { useLanguage } from './language/LanguageContext';

function Landingpage() {
  const Navigate = useNavigate();
  const { language } = useLanguage();
  const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
 // Add state for loading
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');

 
  useEffect(() => {
    const vendorDataString = localStorage.getItem('vendorData');

   if (vendorDataString) {
      try {
        // Parse the JSON string
        const vendorData = JSON.parse(vendorDataString);
        
        // Set vendorId and token in sessionStorage
        sessionStorage.setItem('vendorId', vendorData.id);
        sessionStorage.setItem('token', vendorData.token);
        localStorage.setItem('userId', vendorData.id);

        
        setIsLoading(true);
        setLoadingMessage(content[language].checkingUser);
        Navigate('/supplier/home');
      
      // Function to fetch notifications and navigate
      //   const fetchNotificationsAndNavigate = async () => {
      //     try {
      //       setLoadingMessage(content[language].fetchingNotifications);
            
      //       const response = await fetch(
      //         `${fetchUrl}customer/quotations/get-live-order-notifications?userId=${vendorData.id}`,
      //         {
      //           method: 'GET',
      //           headers: {
      //             'Content-Type': 'application/json',
      //             'x-token': vendorData.token,
      //           },
      //         }
      //       );

      //     const notificationData = await response.json();

      //     setLoadingMessage(content[language].redirecting);

      //     if (notificationData.success && Array.isArray(notificationData.data)) {
      //       const eligibleNotifications = notificationData.data.filter(notification => 
      //         notification.metadata && 
      //         (notification.metadata.order_status === 'Respond Now' || 
      //          notification.metadata.order_status === 'Awarded')
      //       );

      //       const sortedNotifications = eligibleNotifications.sort((a, b) => 
      //         new Date(b.metadata.order_date) - new Date(a.metadata.order_date)
      //       );

      //       if (sortedNotifications.length > 0) {
      //         const mostRecentNotification = sortedNotifications[0];
      //         Navigate('/supplier/orderdetails', {
      //           state: {
      //             quotationId: mostRecentNotification.metadata.order_id,
      //             vendor_id: vendorData.id,
      //             order_number: mostRecentNotification.metadata.order_number
      //           }
      //         });
      //       } else {
      //         Navigate('/supplier/home');
      //       }
      //     } else {
      //       Navigate('/supplier/home');
      //     }
      //   } catch (error) {
      //     console.error('Error fetching notifications:', error);
      //     Navigate('/supplier/home');
      //   } finally {
      //     setIsLoading(false);
      //   }
      // };

      // Call the function to fetch notifications and navigate
      //  fetchNotificationsAndNavigate();
      } catch (parseError) {
        console.error('Error parsing vendor data:', parseError);
        // Clear invalid localStorage data
        localStorage.removeItem('vendorData');
        sessionStorage.removeItem('vendorId');
        sessionStorage.removeItem('token');
      }
    }
  }, [Navigate, fetchUrl, language]);

  // Content translations
  const content = {
    english: {
      slogan: "Start selling on your Digital Store.",
      subtitle1: "",
      subtitle2: "",
      login: "Login",
      register: "Register",
      noAccount: "Don't have an account?"
    },
    telugu: {
      slogan: "మీ సరఫరా. మా ప్లాట్‌ఫారమ్. పెద్ద ప్రభావం.",
      subtitle1: "",
      subtitle2: "",
      login: "లాగిన్",
      register: "నమోదు",
      noAccount: "ఖాతా లేదా?"
    }
  };

  const t = content[language];

    // Loader Component
  const Loader = () => (
    <div className="fixed inset-0 bg-white bg-opacity-90 flex flex-col items-center justify-center z-50">
      <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-[#D64541] mb-4"></div>
      <p className="text-[#D64541] font-medium text-lg">{loadingMessage}</p>
    </div>
  );

  // If loading, show loader
  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white p-6 font-roboto">
        <div className='w-full flex justify-end'>
          <LanguageSelector />
        </div>
      
      {/* Top Navigation Bar with Logo  */}
      <div className="w-full flex justify-center items-center ">
        <div>
          <img 
            src={Logo} 
            alt="Img" 
            className="h-16 md:h-20"
          />
        </div>
      
      </div>

      {/* Main Content Container */}
      <div className="max-w-3xl w-full bg-white rounded-lg p-8 flex flex-col items-center">
        {/* Portrait Image */}
        <div className="mb-6">
          <img 
            src={Human} 
            alt="Img" 
            className="w-54 h-auto object-cover"
          />
        </div>

        {/* Header Text */}
        <h1 className="text-xl md:text-3xl font-bold text-gray-800 mb-4 text-center">
          "{t.slogan}"
        </h1>

        {/* Paragraph Text */}
       {/*  <p className="text-gray-600 text-center max-w-xl">
          {t.subtitle1}
        </p>
        <p className="text-gray-600 mb-8 text-center max-w-xl">
          {t.subtitle2}
        </p> */}
        
        {/* Buttons */}
        <div className="flex flex-col md:flex-row gap-4 w-full max-w-md">
          {/* Login Button */}
          <div className="flex-1">
            <button 
              onClick={() => Navigate('/supplier/login')}
              className="bg-[#D64541] hover:bg-[#D64541] text-white font-medium py-3 px-6 rounded-md transition duration-300 w-full text-center"
            >
              {t.login}
            </button>
          </div>
          
          {/* Register Button with text above */}
          <div className="flex-1 flex flex-col">
            <p className='text-[#827E7E]  text-left font-semibold mb-1 md:hidden'>{t.noAccount}</p>
            <button 
              onClick={() => Navigate('/supplier/register')}
              className="bg-white border-2 border-[#D64541] text-[#D64541] hover:bg-gray-50 font-medium py-3 px-6 rounded-md transition duration-300 w-full text-center"
            >
              {t.register}
            </button>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="mt-8 text-sm text-gray-500">
        © {new Date().getFullYear()} BrickBucket. All rights reserved.
      </div>
    </div>
  );
}

export default Landingpage;
